import type { OrgContextModelApiResponse } from '@provider-directory/components/org-context/org-context-model';
import type { FlagContextType } from '@provider-directory/types/flags';

export interface SdkConfigApiResponse extends OrgContextModelApiResponse {
  featureFlags: FlagContextType;
}

export const getSDKScriptElement = (
  doc: Document,
): HTMLScriptElement | null => {
  return doc.querySelector('script[src*="provider-search-sdk.umd.js"]');
};

export const getSDKBaseURL = (doc: Document, path?: string): string => {
  const scriptElement = getSDKScriptElement(doc);
  const scriptSrc = scriptElement?.getAttribute('src');
  const match = scriptSrc?.match(/^https?:\/\/[^/]+(?:\/[^/]+)*\//);

  return match ? [match[0], path].join('') : '';
};

/**
 * Requests the app's API so we can identify the current organization
 * context and return it.
 */
export const fetchSDKOrgContext = async (): Promise<
  SdkConfigApiResponse | undefined
> => {
  try {
    const configUrl = getSDKBaseURL(document, 'config');

    const response = await fetch(configUrl);
    const parsed = await response.json();

    return parsed as SdkConfigApiResponse;
  } catch (error: unknown) {
    console.warn('Error fetching config:', error);
    return undefined;
  }
};
